module.exports = __webpack_public_path__ + "static/media/support.3024827b.png";